<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-jump-to`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 4c1.01 0 1.914.904 1.994 1.863L44 6v36c0 .962-.858 1.91-1.856 1.994L42 44H6c-1.01 0-1.914-.904-1.994-1.863L4 42V30h4v10h32V8H8v10H4V6c0-.962.858-1.91 1.857-1.994L6 4h36zM23.835 16.207l7.115 7.114a1 1 0 010 1.414l-7.071 7.072a1 1 0 01-1.415 0l-1.414-1.415a1 1 0 010-1.414L24.028 26H5a1 1 0 01-1-1v-2a1 1 0 011-1h18.972l-2.965-2.965a1 1 0 010-1.414l1.414-1.414a1 1 0 011.415 0z"/></svg>
</template>
<script>

export default {
  name: 'IconJumpTo',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
